<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <slot name="header">
                            <h4>{{title}}</h4>
                        </slot>
                    </div>
                    <div class="modal-body">
                        <slot name="body">{{body}}</slot>
                    </div>
                    <div class="modal-footer">
                        <slot name="footer">
                            <button class="modal-default-button btn btn-primary" @click="buttonAction">{{button}}</button>
                        </slot>
                        <button class="modal-default-button btn" @click="$emit('close')">{{$t('CLOSE')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
        data() {
            return {

            }
        },
        props: {
            title: String,
            body: String,
            button: String
        },
        methods: {
            buttonAction: function () {
                this.$emit('action');
                this.$emit('close');
            }
        },
        mounted: function () {

        }
    }</script>

<style scoped lang="scss">
    @import "~bootstrap/dist/css/bootstrap.min.css";
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 90%;
        max-width: 480px;
        margin: 0px auto;
        padding: 5px 10px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h4 {
        margin-top: 0;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }
</style>